"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchPreviewProduct = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _clsx = _interopRequireDefault(require("clsx"));
var _searchPreviewProductClasses = require("../../containers/SearchPreviewProductContainer/searchPreviewProductClasses");
var _searchPreviewProductContext = require("../../contexts/searchPreviewProductContext");
var _Buttons = require("../Buttons");
var _Prices = require("../Prices");
var _ProductImage = require("../ProductImage");
var _ProductInfo = require("../ProductInfo");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const SearchPreviewProduct = () => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    onProductClick,
    url,
    className
  } = (0, _searchPreviewProductContext.useSearchPreviewProduct)();
  const rootClassName = (0, _clsx.default)(_searchPreviewProductClasses.searchPreviewProductClasses.root, className);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Root, {
    className: rootClassName,
    "data-testid": getTestId(_constants.SEARCH_PREVIEW_PRODUCT),
    isClickable: onProductClick !== undefined,
    href: url ?? undefined,
    onClick: onProductClick,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductImage.ProductImage, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Inner, {
      className: _searchPreviewProductClasses.searchPreviewProductClasses.inner,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Info, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProductInfo.ProductInfo, {})
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.PriceAndButton, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Price, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Prices.Prices, {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Buttons.Buttons, {})]
      })]
    })]
  });
};
exports.SearchPreviewProduct = SearchPreviewProduct;
//# sourceMappingURL=SearchPreviewProduct.js.map